/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cg-theme-background[_ngcontent-%COMP%]{background:0 0/cover #eee;display:block;filter:blur(3px);-webkit-filter:blur(3px);height:100%;width:100%;top:0;left:0;position:fixed;right:0;z-index:-1}"];
export { styles as styles };
